
function Card({ children, style={}, className="", id }) {
  return <section id={id} className={`cc-card cc-section-card ${className}`} style={style}>{children}</section>;
}
export default Card;
